import { httpRequest } from "@/utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";

//客户信息
export interface IVRMCustomerInfo {
    contact: string,
    phone: string,
    note: string
}

//详情
export interface IVRMCustomerDetail {
    id?: string,
    branch?: string,                       
    ver?: number,                          
    enable?: number,    
    code?:string,                   
    orgCode?: string | null,               
    orgName?: string | null,               
    shopId?: string | null,                
    shopName?: string | null,              
    linkCode?: string | null,              
    name?: string,                         
    typeCode?: string | null,              
    typeName?: string | null,              
    level?: number,                        
    contact?: string,                      
    phone?: string,                        
    tel?: string,                          
    fax?: string,                          
    email?: string,                        
    website?: string,                      
    address?: string,                      
    invoiceTitle?: string | null,          
    licenseNo?: string | null,             
    bank?: string,                         
    bankAcct?: string | null,              
    bankPhone?: string | null,             
    postAddress?: string | null,           
    corporation?: string,                  
    businessScope?: string,                
    status?: number,                       
    note?: string,                         
    staffCode?: string | null,             
    staffName?: string | null,             
    attrCode?: string | null,              
    attrName?: string | null,              
    isInternal?: string | null,            
    createTime?: string,    
    categoryName?:string,
    categoryCode?:string               
}

//搜索条件
export interface IVRMCustomerSearchFields {
    shopId?: string,
    code?: string,
    name?: string,
    typeCode?: string,
    contact?: string,
    phone?: string,
    enable?: string,
}

export interface IVRMCustomerSearch
    extends IVRMCustomerSearchFields, ISearchPage {

}
export interface Params {
    id: string,
    enable: number
}
class CustomerService {
    async page(searchVo: IVRMCustomerSearch) {
        const apiUrl = "/vrm-sa/base/customer/findPage";
        return await httpRequest.post<IPage<IVRMCustomerDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/base/customer/findById/${id}`;
        return await httpRequest.get<IVRMCustomerDetail>(apiUrl);
    }
    async insert(insertVo: IVRMCustomerDetail) {
        const apiUrl = "/vrm-sa/base/customer/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IVRMCustomerDetail) {
        const apiUrl = "/vrm-sa/base/customer/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(params: Params) {
        const apiUrl = `/vrm-sa/base/customer/change`;
        return await httpRequest.post<boolean>(apiUrl,params);
    }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/vrm-sa/base/customer/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: IVRMCustomerSearch) {
        const appPageUrl = "/vrm-sa/base/customer/export";
        return await httpRequest.postFile(appPageUrl, searchVo);
    }
    //供应商转客户
    async transfer(id: string) {
        const appPageUrl = `/vrm-sa/base/customer/transfer/${id}`;
        return await httpRequest.post<boolean>(appPageUrl);
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/vrm-sa/base/customer/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
}

export const customerService = new CustomerService();
